import React, { useState } from 'react';
import { Button, Form, Input, Space, Tag } from 'antd';
import {
  REJECTION_REASON_CHIPS,
  buildRejectionReason,
  isRejectionReasonValid,
} from './approvalQuotationUtils';

const { TextArea } = Input;
const { CheckableTag } = Tag;

const MAX_CUSTOM_LENGTH = 200;

export default function QuotationRejectReasonPanel({
  onConfirm,
  confirmLabel = 'Confirm Rejection',
  loading = false,
  inDialog = false,
}) {
  const [selectedChips, setSelectedChips] = useState([]);
  const [customText, setCustomText] = useState('');

  const reasonPreview = buildRejectionReason(selectedChips, customText);
  const isValid = isRejectionReasonValid(selectedChips, customText);

  const toggleChip = (chip, checked) => {
    setSelectedChips((prev) =>
      checked ? [...prev, chip] : prev.filter((c) => c !== chip)
    );
  };

  const handleFinish = () => {
    if (!isValid) return;
    onConfirm(reasonPreview);
  };

  return (
    <Form
      layout="vertical"
      className={`Quotation_rejectPanel ${inDialog ? 'Quotation_rejectPanel--inDialog' : ''}`}
      onFinish={handleFinish}
    >
      <Form.Item
        label={
          <>
            Select one or more reasons <span className="Quotation_rejectPanel_required">*</span>
          </>
        }
        className="Quotation_rejectPanel_formItem"
      >
        <Space size={[6, 6]} wrap className="Quotation_rejectPanel_chips">
          {REJECTION_REASON_CHIPS.map((chip) => (
            <CheckableTag
              key={chip}
              checked={selectedChips.includes(chip)}
              onChange={(checked) => toggleChip(chip, checked)}
            >
              {chip}
            </CheckableTag>
          ))}
        </Space>
      </Form.Item>

      <Form.Item
        label="Additional details"
        help={
          <div className="Quotation_rejectPanel_meta">
            <span>
              <span className="Quotation_rejectPanel_required">*</span>
              A reason is required before you can reject
            </span>
            <span>
              {customText.length}/{MAX_CUSTOM_LENGTH}
            </span>
          </div>
        }
        className="Quotation_rejectPanel_formItem"
      >
        <TextArea
          rows={3}
          placeholder="Add additional details (optional if a reason above is selected)"
          value={customText}
          maxLength={MAX_CUSTOM_LENGTH}
          onChange={(e) => setCustomText(e.target.value)}
        />
      </Form.Item>

      <Form.Item className="Quotation_rejectPanel_actionsItem">
        <div className="Quotation_rejectPanel_actions">
          <Button
            type="primary"
            danger
            htmlType="submit"
            disabled={!isValid}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
}
